import Markdown from 'react-markdown';

import { Cms } from '@bytel/product-wall';
import { IconName } from '@bytel/trilogy-react';

import type { MobilePlanType } from '@app-types/plan';

import { NuggetsList } from '@components/nuggets-list';

import { getOfferCardNuggets } from '@helpers/offer-card-nuggets';

interface OfferCardPepitesProps {
    offer: MobilePlanType;
}

export function OfferCardPepites({ offer }: Readonly<OfferCardPepitesProps>) {
    return (
        <div data-cy='offer-card-pepites'>
            <NuggetsList
                nuggets={getOfferCardNuggets(offer).map((nugget) => ({
                    key: nugget.key,
                    icon: nugget.iconName ?? IconName.CHECK,
                    content:
                        nugget.format === 'cms' ? (
                            <span className='is-prewrap'>
                                <Cms as='span' content={nugget.content} />
                            </span>
                        ) : (
                            <span className='is-prewrap'>
                                <Markdown
                                    components={{
                                        p: 'span',
                                    }}
                                >
                                    {nugget.content}
                                </Markdown>
                            </span>
                        ),
                }))}
            />
        </div>
    );
}
